import { ReactNode } from 'react';
import { useParams } from 'react-router-dom';

import { useClients } from '../hooks/useClients';

const searchParams = new URLSearchParams(window.location.search);

export type ClientWrapperProps = {
  explicitCompanyUuid?: string | null;
  children: ReactNode;
};

export const ClientWrapper = ({ explicitCompanyUuid, children }: ClientWrapperProps) => {
  const { companyUuid } = useParams();
  const companyUuidFromParams = searchParams.get('company') || undefined;

  const { token } = useClients({
    companyUuid: explicitCompanyUuid || companyUuid || companyUuidFromParams,
  });

  if (!token) return null;

  return <>{children}</>;
};
